export class GenderReducerState {
  female?: boolean;
  male?: boolean;
  otherThirdGender?: boolean;

  constructor (
    female?: boolean,
    male?: boolean,
    otherThirdGender?: boolean,
  ) {
    this.female = female || false;
    this.male = male || false;
    this.otherThirdGender = otherThirdGender || false;
  }
}